import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import MainContent from '../main-content/main-content';
import TopBar from '../topbar/topbar';
import BottomNav from '../bottom-nav/bottom-nav';

const MobileLayout = ({ logoPath }) => (
  <div className="cm-dashboard flex h-[calc(100vh-0rem)] flex-col overflow-hidden">
    <TopBar logoPath={logoPath} />
    <div className="flex flex-1 overflow-hidden relative">
      <MainContent>
        <Outlet />
      </MainContent>
    </div>
    <BottomNav />
  </div>
);

MobileLayout.defaultProps = {
  logoPath: '',
};

MobileLayout.propTypes = {
  logoPath: PropTypes.string,
};

export default MobileLayout;
